import {
  AccessibilityPopUp,
  Footer
} from '../../components/molecules/footer-slim/models/footer-slim.interfaces';
import {
  Header,
  Logo
} from '../../components/molecules/header-slim/models/header-slim.interfaces';

/** Contains all information that appears on Session Timeout modal */
export interface SessionTimeoutMessage {
  id: string;
  sessionTimeoutMessageTitle: string;
  sessionTimeoutMessageDescription: string;
  logOutText: string;
  loggedInText: string;
}

/** Holds flag and class for theme */
export interface DarkSite {
  isEnabled: string | boolean;
  level: string;
}

/** List of Supported browser icons to upgrade E.g., Firefox, Safari */
export interface BrowserIconValuesEntity {
  browserIconLogo: string;
  browserIconLink: string;
  browserIconTarget: string;
  iconText: string;
}

/** Holds all the content of  Popup that appears when to Upgrade Browser */
export interface UnsupportedBrowserPopup {
  id: string;
  heading: string;
  title: string;
  browserDescription: string;
  ctaLabel: string;
  ctaUrl: string;
  disclaimerText: string;
  footnoteTitle: string;
  footnoteDescription: string;
  browserIconValues?: BrowserIconValuesEntity[] | null;
}

/** Holds content of CookiePolicy popup that appears at footer */
export interface CookiePolicy {
  id: string;
  alertMessage: string;
  countryList?: string[] | null;
}

/** Holds lables that display on airport lookup modal   */
export interface AirportLookup {
  label: string;
  originLabel: string;
  destinationLabel: string;
  cityOrAirport: string;
  fullAirportList: string;
  lookupLabel: string;
  countryLabel: string;
  countries: string;
  usAndCanada: string;
  usCanadaProvince: string;
  alphabeticallyLabel: string;
  airportsLabel: string;
  search: string;
  recentSearch: string;
  savedSearch: string;
  odPairRestriction: string;
}

/** Holds list of Advisory message that appears above the header */
export interface ApplicationAdvisoriesListEntity {
  title: string;
  apptype: string;
  advisoryKey: string;
  pageUrl: string;
}

/** Holds Advisory  labels that appears above the header */
export interface Applicationadvisories {
  alertAdvisoriesLabel: string;
  viewAllAdvisoriesLabel: string;
  viewAllAdvisoriesLink: string;
  advisoriesNewWindow: string;
  defaultDisplay: string;
  ApplicationAdvisoriesList?: ApplicationAdvisoriesListEntity[] | null;
}

/** Holds Advisory message  E.g., "Coronavirus Updates", "Lagos Operations" */
export interface AdvisoriesListEntity {
  title: string;
  Description: string;
  pageurl: string;
  timestamp: string;
}

/** Holds Advisory list messages  E.g., "Coronavirus Updates", "Lagos Operations" */
export interface Advisories {
  AdvisoriesList?: AdvisoriesListEntity[] | null;
}

/**
 * AEM Header/Footer content interfaces
 */
export interface HeaderFooterInformation {
  header: Header;
  footer: Footer;
  advisories: Advisories;
  applicationadvisories: Applicationadvisories;
  accessibilityPopUp: AccessibilityPopUp;
  airportLookup: AirportLookup;
  cookiePolicy: CookiePolicy;
  unsupportedBrowserPopup: UnsupportedBrowserPopup;
  sessionTimeoutMessage: SessionTimeoutMessage;
  darkSite: DarkSite;
  logo: Logo;
  flightPlusHotel: Record<string, string>;
  nonJVFlying: Record<string, string>;
  axBrandName: string;
}
